import styled from 'styled-components';
import KIAImage from '../ui/image/KIAImage';

const FleetCalcPuffStyled = styled.section`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 40px;

  .cta span {
    font-family: 'kiab', sans-serif;
  }

  .cta a {
    color: #fff !important;
    background-color: #000;
    margin-top: 34px;
    padding: 19px 24px;
    line-height: 18px;
    text-decoration: none !important;
  }

  .cta {
    margin-top: 34px;
  }

  .cta .rounded-full {
    position: relative;
  }

  .cta span.rounded-full::after {
    content: ' ';
    float: none;
    width: 6px;
    height: 9px;
    background: url(https://www.kia.com/etc.clientlibs/settings/wcm/designs/eut/clientlib/resources/rbr/icons/spr-button.png) -28px -71px
      no-repeat;
    margin: -5px -4px 0 0;
    display: block;
    position: absolute;
    top: 50%;
    right: 12px;
    overflow: hidden;
  }

  @media (max-width: 768px) {
    flex-direction: column;
  }

  & > img {
    height: auto;

    @media (max-width: 768px) {
      width: 100%;
      height: 290px;
      object-fit: cover;
    }
  }

  & > .fleet_calc_puff__content {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }
`;

interface Props {
  title: string;
  text: string;
  link: string;
  image: string;
  subTitle: string;
  linkText: string;
}

const FleetCalcPuff = ({
  title,
  subTitle,
  text,
  link,
  linkText,
  image,
}: Props) => {
  return (
    <FleetCalcPuffStyled>
      <KIAImage
        sizes="(max-width: 768px) 100vw, 290px"
        alt="Räkna på tjänstebil"
        src={image}
      />
      <div className="fleet_calc_puff__content">
        <h3 className="pre_header">{title}</h3>
        <h3>{subTitle}</h3>
        <p>{text}</p>
        <span className="cta">
          <a className="link-button" href={link}>
            {linkText}
          </a>
        </span>
      </div>
    </FleetCalcPuffStyled>
  );
};

export default FleetCalcPuff;
